module.exports = __webpack_public_path__ + "static/media/card-temp-Charile-inactive.fed8a930.svg";